<app-content-area
  [title]="'CLIENTS_LIST.TITLE' | translate"
  (emitterEventActionClick)="handleContentAreaEvent($event)"
  [actions]="contentAreaActions"
>
  <app-filter-area
    (emitterEventActionClick)="handleFilterAreaEvent($event)"
  >
    <app-input
      type="text"
      mask="cpf"
      [label]="'CLIENTS_LIST.FILTERS.DOCUMENT' | translate"
      [placeholder]="'CLIENTS_LIST.FILTERS.DOCUMENT_PLACEHOLDER' | translate"
      [control]="form.get('document')"
    ></app-input>
    <app-input
      type="text"
      [label]="'CLIENTS_LIST.FILTERS.SOCIAL_REASON' | translate"
      [placeholder]="'CLIENTS_LIST.FILTERS.SOCIAL_REASON_PLACEHOLDER' | translate"
      [control]="form.get('name')"
    ></app-input>
    <app-select
      [label]="'CLIENTS_LIST.FILTERS.PERSON_TYPE.TITLE' | translate"
      [placeholder]="'CLIENTS_LIST.FILTERS.PERSON_TYPE.PLACEHOLDER' | translate"
      [control]="form.get('isHeadOffice')"
      [items]="personTypeOptions"
    ></app-select>
    <app-select
      label="{{ 'CLIENTS_LIST.FILTERS.STATUS' | translate }}"
      placeholder="{{ 'CLIENTS_LIST.FILTERS.STATUS_PLACEHOLDER' | translate }}"
      [items]="statusOptions"
      [control]="form.get('status')"
    ></app-select>
  </app-filter-area>
  <app-table
    [dataList]="dataList"
    [legends]="tableLegends"
    [displayedColumns]="displayedColumns"
    (emitterEventActionClick)="handleEmitterEventActionClick($event)"
    (sortChanged)="onSortChange($event)"
    [actions]="tableActions"
    [length]="length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    (paginate)="handlePaginatorClick($event)"
  />
</app-content-area>
